import React from "react";
import styled, {css} from "styled-components";
import {ReactUtils} from "../../utils/ReactUtils";
import type {Button} from "../../widgets/button/Button";
import {baseDistance, fontSize, fontWeight, radius} from "../styles/styles";
import {colorPalette} from "../styles/colorPalette";

interface ISettingOptionProps {
	readonly label: string;
	readonly children?: React.ReactElement<Button> | React.ReactElement<Button>[];
	readonly selected: boolean;
	readonly onClick: () => void;
	readonly isHelpHovered?: boolean;
}

export const SettingOptionV5 = (props: ISettingOptionProps) => {
	const {selected, label, children, isHelpHovered, onClick} = props;
	const isGroup = !!children;

	const handleOnClick = (event: React.MouseEvent) => {
		event.stopPropagation();
		if (!isGroup) {
			onClick();
		}
	};

	return (
		<SettingOptionContainerStyled
			onClick={handleOnClick}
			className={ReactUtils.cls("SettingOption", {
				selected,
				group: isGroup,
			})}
			$selected={selected}
			data-cy={`SettingOption.${label}`}
		>
			<SettingsLabelContentStyled
				$selected={selected}
				$isHelpHovered={isHelpHovered}
			>
				{label}
			</SettingsLabelContentStyled>
			{children}
		</SettingOptionContainerStyled>
	);
};

const SettingOptionContainerStyled = styled.div<{$selected: boolean}>`
	display: flex;
	flex-direction: column;
	width: 100%;

	&:not(.group) {
		cursor: pointer;
	}

	${(props) => {
		if (props.$selected) {
			return css`
				background-color: ${colorPalette.primary.c500Primary};
				border-radius: ${radius.sm};
				color: ${colorPalette.white};
				height: 32px;
				width: 168px;
				padding: 0px, 0px, 0px, ${baseDistance.sm};
			`;
		}
	}}
`;

export const SettingsLabelContentStyled = styled.div<{$selected: boolean; $isHelpHovered: boolean}>`
	display: flex;
	align-items: center;
	padding: ${baseDistance.xs};
	height: 32px;
	width: 100%;
	font-size: ${fontSize.md};
	font-weight: ${fontWeight.bold};

	${SettingOptionContainerStyled}:not(.group) &:hover {
		width: 168px;
		border-radius: ${radius.sm};
		background: ${(props) =>
			props.$selected ? colorPalette.primary.c500Primary : props.$isHelpHovered ? "#b7bdc0" : colorPalette.blueGray.c200Light};
	}
`;
